export default __webpack_public_path__ + "static/media/mysql-backup.b30a852a.svg";